import * as Actions from '../actions';

const initialState = {
    role: 'guest',
    data: {
        'displayName': 'John Doe',
        'photoURL': 'assets/images/avatars/Velazquez.jpg',
        'photoID': 0,
        'email': 'johndoe@withinpixels.com',
        'token': null,
        'role_info': {
            role_id: 0
        },
        shortcuts: [
            'calendar',
            'mail',
            'contacts',
            'todo'
        ]
    },
    tokenCheck: false,
};

const user = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_USER_DATA:
            {
                return {
                    ...initialState,
                    ...action.payload,
                    tokenCheck: true
                };
            }

        case Actions.REMOVE_USER_DATA:
            {
                return {
                    ...initialState
                };
            }

        case Actions.USER_LOGGED_OUT:
            {
                return {
                    ...initialState,
                    tokenCheck: true,
                };
            }

        case Actions.SET_TOKEN_CHECK:
            {
                return {
                    ...initialState,
                    tokenCheck: true
                }
            }

        case (Actions.UPDATE_STUDENT_USER_COURSES):
            {
                return {
                    ...state,
                    all_roles: state.all_roles.map(role => {
                        if (role.role_id === 4) {
                            return {
                                ...role,
                                link_info: {
                                    ...role.link_info,
                                    ActiveCourses: action.payload
                                }
                            }
                        }
                        return role
                    })
                }
            }
        case (Actions.UPDATE_USER_ROLES):
            {
                return {
                    ...state,
                    NewUser: action.payload.role_info.IsNewUser === 0 ? false : true,
                    all_roles: action.payload.roles,
                    data: {
                        ...state.data,
                        role_info: action.payload.role_info,
                        permissionList: action.payload.permission.permissionList
                    }
                }
            }

        default:
            {
                return state
            }
    }
};

export default user;


// WEBPACK FOOTER //
// src/auth/store/reducers/user.reducer.js